import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tabId"];
import { THREAD_COMMENT } from 'conversations-message-history/comment-message/constants/messageTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tab } from 'foundations-components/transitional/components/Tabs';
import { jsx as _jsx } from "react/jsx-runtime";
export function CommentTab(_ref) {
  let {
      tabId
      // necessary for passing through tab data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tab, Object.assign({
    tabId: tabId,
    "data-tab-id": tabId,
    "data-channel-id": THREAD_COMMENT,
    "data-test-id": "INTERNAL-dropdown-trigger",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.capability-editor.channel-label.comment"
    })
  }, rest));
}
CommentTab.displayName = 'CommentTab';